import React, { DetailedHTMLProps } from 'react';
import classNames from 'classnames';

interface InfoIconButtonProps extends Omit<DetailedHTMLProps<
	React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement
>, 'aria-label'> {
	hasError?: boolean;
	ariaLabel: string;
}

const InfoIconButton = (props: InfoIconButtonProps) => {
	const {
		className,
		hasError,
		ariaLabel,
		...rest
	} = props;

	return (
		<span
			className={
				classNames(
					'info-icon-button btn--icon-only icon-only icon-left icon-info',
					className,
					{ error: hasError },
				)
			}
			role="button"
			tabIndex={0}
			aria-label={hasError ? `${ariaLabel} violation info` : `${ariaLabel} info`}
			{...rest}
		>
			<span className="screen-reader-only">{hasError ? `${ariaLabel} violation info` : `${ariaLabel} info`}</span>
		</span>
	);
};

export default InfoIconButton;
